import {h, Component} from 'preact';
import {getCookie, removeCookie} from "../utils/Cookie";
import {observer} from "mobx-preact";
import {observable} from "mobx";

@observer
class ScarCityBar extends Component {
    @observable countDown = null;

    constructor(props) {
        super(props);
        this.campaignStore = props.campaignStore;
        this.winPageStore = props.winPageStore;
        this.couponCode = getCookie('kol_wheel_scarcity_coupon_code');
        this.countDown = this.getCountDown();
        this.isAdminComponent = props.isAdminComponent;
        if (this.isAdminComponent){
            window.setScarCityBar = this.campaignStore.setScarCityBar;
            const eventScarCityLoaded = new Event('scarCityBarLoaded');
            document.dispatchEvent(eventScarCityLoaded);

        }
        if (this.countDown) {
            setInterval(() => this.countDown = this.getCountDown(), 1000);
        }
    }

    componentDidMount() {
        this.campaignStore.setScarCityBarColors(this.scarCityBar);
    }


    getCountDown = () => {
        const gameDateTime = getCookie('kol_wheel_app_show_scarcity');
        if (!gameDateTime) {
            return null
        }
        const scarcityExpiresTimestamp = Number.parseInt(gameDateTime) + Number.parseInt(this.campaignStore.scarCityBarCountdownTime * 60 * 1000);
        const timestampNow = Date.now();
        if (scarcityExpiresTimestamp < timestampNow) {
            return null
        }
        const delta = scarcityExpiresTimestamp - timestampNow;
        const deltaMinutes = Math.floor(delta / 1000 / 60);
        const deltaSeconds = Math.floor(delta / 1000) - (deltaMinutes * 60);
        return `${deltaMinutes.toString().padStart(2, '0')}:${deltaSeconds.toString().padStart(2, '0')}`

    }
    hideScarCityBar = (e) => {
        e.preventDefault();
        if (!this.isAdminComponent) {
            removeCookie('kol_wheel_app_show_scarcity');
            this.countDown = null;
        }
    }

    render() {
        if (!this.countDown && !this.isAdminComponent) {
            return
        }
        const positionStyles = {[this.campaignStore.scarCityBarPosition]: 0};
        if (this.isAdminComponent){
            positionStyles['position'] = 'absolute';
        }
        return <div id="kol-scarcity-bar" style={positionStyles} className="kol-scarcity-bar" ref={scarCityBar => this.scarCityBar = scarCityBar}>
            <span className="kol-scarcity-bar__text">{this.campaignStore.scarCityBarText}</span>
            <span className="kol-scarcity-bar__coupon">{this.couponCode}</span>
            <span className="kol-scarcity-bar__timer">{this.campaignStore.scarCityBarCountdownText} {this.countDown}</span>
            <button className="kol-scarcity-bar__close" onClick={this.hideScarCityBar}>
                <svg width="16" height="16">
                    <path
                        d="M15.35 14.65a.48.48 0 0 1 0 .7.48.48 0 0 1-.7 0L8 8.71l-6.65 6.64a.47.47 0 0 1-.35.15.47.47 0 0 1-.35-.15.48.48 0 0 1 0-.7L7.29 8 .65 1.35a.48.48 0 0 1 0-.7.48.48 0 0 1 .7 0L8 7.29 14.65.65a.48.48 0 0 1 .7 0 .48.48 0 0 1 0 .7L8.71 8z"/>
                </svg>
            </button>
        </div>
    }
}

export default ScarCityBar;
